import { Menu, MenuButton, MenuList, MenuItem } from "@reach/menu-button"

interface StatementYearFilterProps {
  statementYears: number[]
  activeStatementYear?: number | null
  onChange: (year: number) => void
}

export function StatementYearFilter({
  statementYears,
  activeStatementYear,
  onChange,
}: StatementYearFilterProps) {
  const handleStatementYearChange = (year: number) => {
    onChange(year)
  }

  return (
    <Menu>
      <MenuButton className="select ta-l w-50%@md">
        {activeStatementYear}
      </MenuButton>
      <MenuList>
        {statementYears.map((year, index) => (
          <MenuItem
            key={index}
            onSelect={() => handleStatementYearChange(year)}
          >
            {year}
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  )
}
